export default function GuideSection() {
  const steps = [
    {
      step: '01',
      title: '访问官网',
      desc: '通过搜索引擎搜索"海角论坛官网"进入，建议收藏网址方便下次访问',
      icon: 'ri-global-line',
    },
    {
      step: '02',
      title: '注册账号',
      desc: '点击右上角"注册"按钮，输入手机号或邮箱，设置密码和昵称完成注册',
      icon: 'ri-user-add-line',
    },
    {
      step: '03',
      title: '登录论坛',
      desc: '使用注册的账号和密码登录，即可浏览帖子、参与讨论和发表内容',
      icon: 'ri-login-box-line',
    },
    {
      step: '04',
      title: '探索版块',
      desc: '选择感兴趣的版块浏览内容，或使用搜索功能查找特定话题',
      icon: 'ri-compass-3-line',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            海角论坛入口与使用指南
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            只需简单几步即可加入海角论坛，开始你的社区之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {steps.map((s, i) => (
            <div key={i} className="relative text-center p-6">
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-3 w-6 text-foreground-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line"></i>
                  </div>
                </div>
              )}
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-5">
                <i className={`${s.icon} text-xl text-primary-600`}></i>
              </div>
              <span className="inline-block text-xs font-bold text-primary-400 mb-2">{s.step}</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {s.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 md:p-8 bg-primary-50 rounded-lg border border-primary-100 text-center">
          <p className="text-sm text-foreground-700 mb-4">
            <strong className="text-foreground-900">温馨提示：</strong>
            请认准海角论坛官网入口，谨防仿冒网站。建议将官方网址添加到浏览器收藏夹，方便下次快速访问。
          </p>
          <button className="px-6 py-2.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer">
            海角论坛最新地址
          </button>
        </div>
      </div>
    </section>
  );
}